import SubscriptionInterval from "@mapmycustomers/shared/enum/SubscriptionInterval";
import CurrentPlan from "@mapmycustomers/shared/types/plans/CurrentPlan";
import Price from "@mapmycustomers/shared/types/plans/Price";
import Tier from "@mapmycustomers/shared/types/plans/Tier";

import { ensureSameCurrency } from "./price";
import { findTierByIntervalAndLicenses } from "./tier";

export interface SavingsInformation {
  canSave: boolean;
  savingInPercents: number;
  savingPrice: Price;
}

const useSavingsInformation = (
  currentPlan: CurrentPlan | undefined,
  tier: Tier | undefined,
  tiers: Tier[]
): SavingsInformation => {
  if (!currentPlan || !tier) {
    return { canSave: false, savingInPercents: 0, savingPrice: { currency: "USD", value: 0 } };
  }

  const canGoToAnnual =
    currentPlan.tier.id === tier.id &&
    currentPlan.tier.interval === SubscriptionInterval.MONTHLY &&
    !currentPlan.tier.isTrial;

  const closestAnnualTier = findTierByIntervalAndLicenses(
    tiers,
    SubscriptionInterval.ANNUAL,
    currentPlan.licenses
  );

  const canSaveSwitchingToAnnual: Price = {
    ...currentPlan.tier.price,
    value: 0,
  };
  let canSaveSwitchingToAnnualInPercents = 0;

  if (canGoToAnnual && closestAnnualTier) {
    ensureSameCurrency(currentPlan.tier.price, closestAnnualTier.price);
    const currentPrice = currentPlan.tier.price.value * currentPlan.licenses * 12;
    const annualPrice = closestAnnualTier.price.value * currentPlan.licenses;
    canSaveSwitchingToAnnual.value = currentPrice - annualPrice;
    canSaveSwitchingToAnnualInPercents = canSaveSwitchingToAnnual.value / currentPrice;
  }

  return {
    canSave: canSaveSwitchingToAnnual.value > 0,
    savingInPercents: canSaveSwitchingToAnnualInPercents,
    savingPrice: canSaveSwitchingToAnnual,
  };
};

export default useSavingsInformation;
